import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import UserItem from '../components/UserItem';
import { CircularProgress } from '@mui/material';

function StalkersList() {
  const { userId } = useParams(); // Get the profile userId
  const location = useLocation(); // Access the state passed via `navigate`
  const navigate = useNavigate();

  const { isOwner } = location.state || {}; // Get `isOwner` from state
  const [stalkers, setStalkers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStalkers = async () => {
    try {
      const res = await axiosInstance.get(`/profile/${userId}/stalkers`);
      setStalkers(res.data || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching stalkers:', err);
      setLoading(false);
    }
  };

  // Remove a stalker (only if the logged-in user is the owner)
  const removeStalker = async (stalkerId) => {
    try {
      await axiosInstance.delete(`/profile/${userId}/stalkers/${stalkerId}`);
      // Reload the updated list
      fetchStalkers();
    } catch (err) {
      console.error('Error removing stalker:', err);
    }
  };

  useEffect(() => {
    fetchStalkers();
  }, [userId]);

  if (loading) {
    return  <div className="loading-container">
              <CircularProgress size={40} sx={{ color: 'black' }} />
            </div>;
  }

  return (
    <div>
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="top-title">Stalkers</h1>
      </div>

      {stalkers.length > 0 ? (
        stalkers.map((user) => (
          <UserItem
            key={user.user_id}
            user={user}
            navigate={navigate}
            // Pass `removeStalker` only if the logged-in user is the owner
            onRemove={isOwner ? () => removeStalker(user.user_id) : null}
          />
        ))
      ) : (
        <p>No stalkers found.</p>
      )}
    </div>
  );
}

export default StalkersList;
